enum SubscriptionTimezoneCity {
  andorra = "andorra",
  astrakhan = "astrakhan",
  athens = "athens",
  belgrade = "belgrade",
  berlin = "berlin",
  brussels = "brussels",
  bucharest = "bucharest",
  budapest = "budapest",
  cayenne = "cayenne",
  chisinau = "chisinau",
  dublin = "dublin",
  gibraltar = "gibraltar",
  pointe_a_pitre = "pointe_a_pitre",
  helsinki = "helsinki",
  istanbul = "istanbul",
  kaliningrad = "kaliningrad",
  kirov = "kirov",
  kyiv = "kyiv",
  lisbon = "lisbon",
  london = "london",
  madrid = "madrid",
  malta = "malta",
  minsk = "minsk",
  moscow = "moscow",
  paris = "paris",
  prague = "prague",
  riga = "riga",
  rome = "rome",
  samara = "samara",
  saratov = "saratov",
  simferopol = "simferopol",
  sofia = "sofia",
  tallinn = "tallinn",
  tirane = "tirane",
  ulyanovsk = "ulyanovsk",
  vienna = "vienna",
  vilnius = "vilnius",
  volgograd = "volgograd",
  warsaw = "warsaw",
  zurich = "zurich",
}

export const subscriptionTimezoneCityAsString = (
  subscriptionTimezoneCity: SubscriptionTimezoneCity
): string => {
  switch (subscriptionTimezoneCity) {
    case SubscriptionTimezoneCity.andorra:
      return "Andorre";
    case SubscriptionTimezoneCity.astrakhan:
      return "Astrakhan";
    case SubscriptionTimezoneCity.athens:
      return "Athènes";
    case SubscriptionTimezoneCity.belgrade:
      return "Belgrade";
    case SubscriptionTimezoneCity.berlin:
      return "Berlin";
    case SubscriptionTimezoneCity.brussels:
      return "Bruxelles";
    case SubscriptionTimezoneCity.bucharest:
      return "Bucarest";
    case SubscriptionTimezoneCity.budapest:
      return "Budapest";
    case SubscriptionTimezoneCity.cayenne:
      return "Cayenne";
    case SubscriptionTimezoneCity.chisinau:
      return "Chisinau";
    case SubscriptionTimezoneCity.dublin:
      return "Dublin";
    case SubscriptionTimezoneCity.gibraltar:
      return "Gibraltar";
    case SubscriptionTimezoneCity.pointe_a_pitre:
      return "Pointe-à-Pitre";
    case SubscriptionTimezoneCity.helsinki:
      return "Helsinki";
    case SubscriptionTimezoneCity.istanbul:
      return "Istanbul";
    case SubscriptionTimezoneCity.kaliningrad:
      return "Kaliningrad";
    case SubscriptionTimezoneCity.kirov:
      return "Kirov";
    case SubscriptionTimezoneCity.kyiv:
      return "Kiev";
    case SubscriptionTimezoneCity.lisbon:
      return "Lisbonne";
    case SubscriptionTimezoneCity.london:
      return "Londres";
    case SubscriptionTimezoneCity.madrid:
      return "Madrid";
    case SubscriptionTimezoneCity.malta:
      return "Malte";
    case SubscriptionTimezoneCity.minsk:
      return "Minsk";
    case SubscriptionTimezoneCity.moscow:
      return "Moscou";
    case SubscriptionTimezoneCity.paris:
      return "Paris";
    case SubscriptionTimezoneCity.prague:
      return "Prague";
    case SubscriptionTimezoneCity.riga:
      return "Riga";
    case SubscriptionTimezoneCity.rome:
      return "Rome";
    case SubscriptionTimezoneCity.samara:
      return "Samara";
    case SubscriptionTimezoneCity.saratov:
      return "Saratov";
    case SubscriptionTimezoneCity.simferopol:
      return "Simferopol";
    case SubscriptionTimezoneCity.sofia:
      return "Sofia";
    case SubscriptionTimezoneCity.tallinn:
      return "Tallinn";
    case SubscriptionTimezoneCity.tirane:
      return "Tirana";
    case SubscriptionTimezoneCity.ulyanovsk:
      return "Oulianovsk";
    case SubscriptionTimezoneCity.vienna:
      return "Vienne";
    case SubscriptionTimezoneCity.vilnius:
      return "Vilnius";
    case SubscriptionTimezoneCity.volgograd:
      return "Volgograd";
    case SubscriptionTimezoneCity.warsaw:
      return "Varsovie";
    case SubscriptionTimezoneCity.zurich:
      return "Zurich";
  }
};

export default SubscriptionTimezoneCity;
